













































































































import { Vue, Component, Provide } from 'vue-property-decorator';
import Map from './force/view/Map.vue';
import Table from './force/view/Table.vue';
import Label from './force/view/Label.vue';
import Button from './force/view/Button.vue';
import Select from './force/view/Select.vue';
import Slider from './force/view/Slider.vue';
import FilterBox from './force/view/FilterBox.vue';
import mapStore, { State } from '../../store/nexus';
import TopHeader from '../top-header/top-header.vue';
import SearchStore from '../../store/SearchStore';
@Component({
    components: {
        Map,
        Table,
        Label,
        Button,
        Slider,
        Select,
        FilterBox,
        TopHeader
    }
})
export default class Home extends Vue {
    isMap: boolean = true;
    isFilter: boolean = false;
    isScreen: boolean = false;
    appdom: HTMLElement = document.body;
    pointNum: { [key: string]: number } = {
        value: 10
    };
    edgeLevel: { [key: string]: number } = {
        value: 2
    };
    sliderChange(type: string, ev: any) {
        switch (type) {
        case 'point':
            mapStore.pointNum = ev;
            break;
        case 'edge':
            mapStore.edgeLevel = ev;
            break;
        default:
            break;
        }
        mapStore.upQuire(mapStore.pointNum, mapStore.edgeLevel);
    }
    clickIco(ev: any) {
        const command: string = ev.command as string;
        switch (command) {
        case 'help':
            break;
        case 'grid':
            this.isMap = false;
            break;
        case 'map':
            this.isMap = true;
            break;
        case 'minscreen':
            this.isScreen = false;
            this.$router.push('/map?screen=0');
            break;
        case 'maxscreen':
            this.isScreen = true;
            this.$router.push('/map?screen=1');
            break;
        default:
            break;
        }
    }
    onClickFilter() {
        this.isFilter = true;
    }
    onClose(ev: { type: string; data?: any }) {
        switch (ev.type) {
        case 'YES':
            mapStore.ruleQuire(ev.data);
            break;
        default:
            break;
        }
        this.isFilter = false;
    }
    onResetMap() {
        this.pointNum = { value: 10 };
        this.edgeLevel = { value: 2 };
    }
    mounted() {
        SearchStore.searchFinanceEnter('');
        this.appdom = document.querySelector('#app') as HTMLElement;
        mapStore.on(mapStore.EVENT_UP_RESET, this.onResetMap.bind(this));
    }
    beforeDestroy() {
        console.log('销毁力导向图');
    }
}
